<app-left-menu></app-left-menu>
<app-header></app-header>
<router-outlet></router-outlet>